import React from 'react'
import { NumericFormat } from "react-number-format";
import PropTypes from 'prop-types'

const DollarOffInput = (props) => {
  const { inputRef, onChange, ...other } = props
  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      thousandSeparator
      allowNegative={false}
      decimalScale={2}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        })
      }}
      prefix='$'
      suffix=' Off'
    />
  )
}

DollarOffInput.propTypes = {
  props: PropTypes.object
}

export default DollarOffInput
